import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-api-fluid-loss-vertical',
  standalone: false,
  templateUrl: './api-fluid-loss-vertical.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class ApiFluidLossVerticalComponent  {
  @Input() apifluidlossTest:any
}
